import Input from "Components/Form/Input";
import SelectSearch from "Components/Form/SelectSearch";
import { useQuery } from "react-query";
import { useState } from "react";
import { getRegions, getStates } from "../../../../Requests/Units";

interface FiltersProps {
  fetchFiltersRequest: (filters: SearchFilters) => void;
  clearFilters: () => void;
}

interface SearchFilters {
  name: string;
  region_id: string;
  uf: string;
  status: string;
  type: string;
}

const listStatus = [
  {
    id: 1,
    name: "Ativa",
  },
  {
    id: 2,
    name: "Inativa",
  },
];

const listTypes = [
  {
    id: "clinica",
    name: "Clínica",
  },
  {
    id: "exames",
    name: "Exames",
  },
  {
    id: "domiciliar",
    name: "Domiciliar",
  },
];

const initialSearchFilters = {
  name: "",
  region_id: "",
  uf: "",
  status: "",
  type: "",
};

export const Filters = ({
  fetchFiltersRequest,
  clearFilters,
}: FiltersProps) => {
  const [filters, setFilters] = useState<SearchFilters>(initialSearchFilters);

  const { data: listRegions } = useQuery({
    queryFn: getRegions,
    queryKey: ["regions"],
    refetchOnWindowFocus: false,
  });

  const { data: listStates } = useQuery({
    queryFn: getStates,
    queryKey: ["states"],
    refetchOnWindowFocus: false,
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    fetchFiltersRequest(filters);
  };

  const handleClearFilters = () => {
    setFilters(initialSearchFilters);
    clearFilters();
  };

  return (
    <div className="order-home-filter full-width">
      <form className="filters-order" onSubmit={handleSubmit}>
        <div className="sm-3">
          <Input
            id="unit_name"
            label=""
            description=""
            error=""
            mask=""
            maskChar=""
            small={false}
            readOnly={false}
            maxLength={200}
            min={1}
            required={false}
            purple={false}
            multiline={false}
            onBlur={() => {}}
            onFocus={() => {}}
            onKeyPress={() => {}}
            type="search"
            placeholder="Busque pelo nome da unidade"
            value={filters?.name || ""}
            onChange={({ target }: any) =>
              setFilters({
                ...filters,
                name: target.value,
              })
            }
          />
        </div>
        <div className="sm-2">
          <SelectSearch
            purple={false}
            required={false}
            key="regions  "
            small={false}
            error=""
            label=""
            id="regions"
            value={filters?.region_id || null}
            isMulti
            isMoreSelect={false}
            options={listRegions}
            loading={!listRegions?.length}
            readOnly={!listRegions?.length}
            valueKey="id"
            labelKey="region"
            placeholder="Regiões"
            onChange={(value: { id: string }) => {
              setFilters({
                ...filters,
                region_id: value.id,
              });
            }}
          />
        </div>
        <div className="sm-2">
          <SelectSearch
            id="states"
            purple={false}
            required={false}
            key="regions  "
            small={false}
            error=""
            label=""
            value={filters?.uf || ""}
            isMulti
            isMoreSelect={false}
            options={listStates}
            loading={!listStates?.length}
            readOnly={!listStates?.length}
            valueKey="id"
            labelKey="state"
            placeholder="Estado"
            onChange={(value: { id: string }) => {
              setFilters({
                ...filters,
                uf: value.id,
              });
            }}
          />
        </div>
        <div className="sm-2">
          <SelectSearch
            id="status"
            purple={false}
            required={false}
            key="regions  "
            small={false}
            error=""
            label=""
            value={filters?.status || ""}
            isMulti
            isMoreSelect={false}
            options={listStatus}
            loading={!listStatus.length}
            readOnly={!listStatus.length}
            valueKey="id"
            labelKey="name"
            placeholder="Status"
            onChange={(value: { id: string }) => {
              setFilters({
                ...filters,
                status: value.id,
              });
            }}
          />
        </div>
        <div className="sm-2">
          <SelectSearch
            id="type"
            purple={false}
            required={false}
            key="regions  "
            small={false}
            error=""
            label=""
            value={filters?.type || ""}
            isMulti
            isMoreSelect={false}
            options={listTypes}
            loading={!listTypes.length}
            readOnly={!listTypes.length}
            valueKey="id"
            labelKey="name"
            placeholder="Tipo de Unidade"
            onChange={(value: { id: string }) => {
              setFilters({
                ...filters,
                type: value.id,
              });
            }}
          />
        </div>
        <div className="full-width ml-10">
          <button type="submit" className="button mr-10" onClick={handleSubmit}>
            Buscar
          </button>
          <button
            id="clean"
            className="button _white mr-10"
            onClick={handleClearFilters}
          >
            Limpar
          </button>
        </div>
      </form>
    </div>
  );
};
